/**
 * @file Re-exports the two factor authentication setup modal.
 */
import TwoFactorAuthenticationModal from "./TwoFactorAuthenticationModal";

export default TwoFactorAuthenticationModal;
